module.exports = "/static/fonts/Framework7Icons-Regular.48c1c71.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/framework7-icons/fonts/Framework7Icons-Regular.ttf
// module id = 802
// module chunks = 2